import { GuaranteeRatingOption } from "../../../../../../types/GuaranteeRatingOption";

export const guaranteeRatingOptions: GuaranteeRatingOption[] = [
  { class: 1, from: 0.00, to: 2.70 },
  { class: 2, from: 2.70, to: 3.50 },
  { class: 3, from: 3.50, to: 5.50 },
  { class: 4, from: 5.50, to: 8.00 },
  { class: 5, from: 8.00, to: 13.00 },
];